// Cancelar/Corrigir comanda com estorno (motivo obrigatório; 403 → senha master). Retorna true se executou.
export const acaoComandaEstorno = async (API, c, corrigir = false) => {
  const rota = corrigir ? 'corrigir' : 'cancelar-com-estorno';
  const motivo = window.prompt(`${corrigir ? 'Corrigir' : 'Cancelar'} ${c.codigo}${c.status === 'paga' ? ' (o recebimento será estornado e o estoque devolvido)' : ''}.\nMotivo (obrigatório):`);
  if (!motivo) return false;
  const post = (body) => fetch(`${API}/comandas/${c.id}/${rota}`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
  let res = await post({ motivo });
  if (res.status === 403) {
    const senha = window.prompt('Autorização necessária. Informe a senha master (ou a senha do ADMIN logado):');
    if (!senha) return false;
    res = await post({ motivo, senha_master: senha });
  }
  if (!res.ok) { const d = await res.json().catch(() => ({})); alert(d?.detail?.message || d?.detail || 'Erro'); return false; }
  if (corrigir) { const d = await res.json(); alert(`Recebimento estornado. Nova comanda ${d.nova.codigo} aberta para corrigir, enviar ao caixa e receber de novo.`); }
  return true;
};
